import React, { FunctionComponent, useState } from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';

import Button from '../../../UI/Button';
import Modal from '../../../UI/Modal';
import RechargeForm from './RechargeForm';
import { sendEvent2 } from '../../../../utils/tracking';

const Recharge: FunctionComponent<{ tagId: string; amount: number; vehicle: string }> = ({
  tagId,
  amount,
  vehicle,
}) => {
  const [modalState, setModalState] = useState(false);
  const walletBalance = useSelector((state: any) => _get(state, 'fasTag.balance', ''));

  const toggleModal = () => {
    if (modalState) {
      sendEvent2(
        'close_btn',
        {
          event_action: 'click',
          event_category: 'ft_vehicle_recharge_pop_up',
          screen_name: 'ft_homescreen',
          target_product: 'fastag',
          event_platform: 'web',
        },
        true,
      );
    }
    setModalState((prevState) => !prevState);
  };

  const updateAction = (modalState: boolean) => setModalState(modalState);

  return (
    <div className="z1">
      <Button
        variant="outlined"
        color="#304FFE"
        style={{ height: '100%' }}
        size="small"
        clickHandler={() => {
          toggleModal();
          sendEvent2(
            'recharge_btn',
            {
              event_action: 'click',
              event_category: 'vehicle_card',
              screen_name: 'ft_homescreen',
              miscellaneous: JSON.stringify({
                current_balance: walletBalance,
              }),
              target_product: 'fastag',
              event_platform: 'web',
            },
            true,
          );
        }}
        hover={true}
      >
        Recharge
      </Button>
      <Modal
        isOpen={modalState}
        onClose={() => {
          toggleModal();
        }}
      >
        <RechargeForm
          tagId={tagId}
          vehicle={vehicle}
          amount={amount}
          walletBal={walletBalance}
          updateAction={updateAction}
        />
      </Modal>
    </div>
  );
};

export default Recharge;
